/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './styles.scss'

interface Props {
  maneuver: string
  customSendDate: number
}

const ManeuverStatus: FC<Props> = ({ maneuver, customSendDate }) => {
  let maneuverText = maneuver
  let maneuverIcon: any = faCircle
  let maneuverColor = '#009BDB'

  // Checked on basis of maneuver
  switch (maneuver) {
    case 'Waiting...':
    case '':
      maneuverText = 'No Maneuver scheduled'
      maneuverIcon = faTimesCircle
      maneuverColor = 'red'
      break
    default: {
      maneuverIcon = faCheckCircle

      if (customSendDate) {
        const formattedSendDate = moment(customSendDate)
          .utcOffset('+0500')
          .format('MM.DD.YYYY')

        let maneuverStr = 'Rev-Up'
        if (maneuver === 'Follow Up') maneuverStr = 'Engaged'
        else if (maneuver === 'Nurture') maneuverStr = 'Re-Engage'

        maneuverText = `${maneuverStr} scheduled: ${formattedSendDate}`
      } else {
        maneuverText = `${!maneuver ? 'First Touch' : maneuver} scheduled`
      }
    }
  }

  // set values on basis of CustomSendDate, if its 0 Then it will not been scheduled yet.
  if (!customSendDate) {
    maneuverText = 'No Maneuver scheduled'
    maneuverIcon = faTimesCircle
    maneuverColor = 'red'
  }

  return (
    <div className="maneuver-status">
      <>
        <div className="maneuver">
          <FontAwesomeIcon
            icon={maneuverIcon}
            color={maneuverColor}
            className={`maneuver-icon
            ${maneuverColor === 'red' ? 'red' : ''}`}
          />
          <p className="text">{maneuverText}</p>
        </div>
      </>
    </div>
  )
}

export default ManeuverStatus
